import React, { memo, useCallback, useContext } from "react";
import { CustomTypography } from "../../../library/custom/CustomTypography/CustomTypography";
import { CustomLink } from "../../../library/custom/CustomLink/CustomLink";
import { CustomGrid } from "../../../library/custom/CustomGrid/CustomGrid";
import { AppTargetPlatform } from "../../../contexts/DownloadContext/types";
import { DownloadContext } from "../../../contexts/DownloadContext/DownloadContext";

const AlsoAvailableForDarwin = memo(() => {
  const {
    actions: { onRequestDownload },
  } = useContext(DownloadContext);

  const handleClickMacIntelDownload = useCallback(() => {
    onRequestDownload({ target: AppTargetPlatform.darwinX64 });
  }, []);

  const handleClickMacAppleDownload = useCallback(() => {
    onRequestDownload({ target: AppTargetPlatform.darwinArm64 });
  }, []);

  return (
    <CustomGrid item container width="fit-content">
      <CustomTypography
        whiteSpace="break-spaces"
        nameSpace="downloading"
        translation="alsoAvailable"
      />
      <CustomLink color="primary">
        <CustomTypography
          nameSpace="downloading"
          color="inherit"
          translation="platforms.macIntel"
          onClick={handleClickMacIntelDownload}
        />
      </CustomLink>
      <CustomTypography
        whiteSpace="break-spaces"
        nameSpace="downloading"
        translation="and"
      />
      <CustomLink color="primary">
        <CustomTypography
          nameSpace="downloading"
          color="inherit"
          translation="platforms.macApple"
          onClick={handleClickMacAppleDownload}
        />
      </CustomLink>
    </CustomGrid>
  );
});

export { AlsoAvailableForDarwin };
